export const HEADER_TITLE = 'Réservez votre session d\'examen, près de chez vous, dans un centre La Poste';
